'use strict';

import axios from 'axios';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import {
  cleanAllErrors,
  handleErrors,
  countErrors
} from '@jspartials/form-utils';
import { gtmLaunchCustomerSignUpSuccessfully } from '@jspartials/gtm-utils';

// Selectors
const selector = {
  form: '.js-fast-sign-up-form',
  button: {
    submit: '.js-fast-sign-up-form__button-submit'
  }
};

// Elements
const element = {};

// Functions

/**
 * Listen the fast sign up form
 * @returns {void}
 */
const listenFastSignUpForm = () => {
  initElements();

  if (element.form) {
    listenDOMEvent(element.form, 'submit', handleFastSignUpFormSubmit);
  }
};

/**
 * Initializes the elements
 * @returns {void}
 */
const initElements = () => {
  element.form = document.querySelector(selector.form) || null;
};

/**
 * Handle the fast sign up form submit
 * @returns {void}
 */
const handleFastSignUpFormSubmit = (event) => {
  event.preventDefault();

  const urlForm = element.form.action;
  const button =
    event.currentTarget.querySelector(selector.button.submit) || null;
  const formData = new FormData(element.form);

  cleanAllErrors();
  enableLoadingState(button);

  axios
    .post(urlForm, formData)
    .then((response) => {
      if (response.status === 200) {
        const responseData = response.data;
        const errors = 'errors' in responseData ? responseData.errors : null;
        const success =
          'success' in responseData ? responseData.success : false;
        const totalErrors = errors ? countErrors(errors) : 0;
        const hashedEmail =
          'hashedEmail' in responseData ? responseData.hashedEmail : '';

        if (totalErrors > 0) {
          handleErrors(errors);
          disableLoadingState(button);
        } else if (success) {
          gtmLaunchCustomerSignUpSuccessfully({
            place: 'pdp',
            hashedEmail: hashedEmail
          });
          window.location.reload();
        } else {
          console.error('ERROR! (success !== true)');
          disableLoadingState(button);
        }
      } else {
        console.error('ERROR! (status !== 200)');
        disableLoadingState(button);
      }
    })
    .catch((error) => {
      console.log('ERROR!');
      console.error(error);
      disableLoadingState(button);
    });
};

/**
 * Enable loading state for an element
 * @param {HTMLElement} element - Element to enable loading state
 */
const enableLoadingState = (element) => {
  if (element) {
    addClassToElement(element, classes.is.loading);
  }
};

/**
 * Disable loading state for an element
 * @param {HTMLElement} element - Element to disable loading state
 */
const disableLoadingState = (element) => {
  if (element) {
    removeClassToElement(element, classes.is.loading);
    element.blur();
  }
};

export { listenFastSignUpForm };
